import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TrialFrame from '../components/TrialFrame';
import RegisterForm from '../components/RegisterForm';
import TrialSignupConfirmation from '../components/TrialSignupConfirmation';

export default function TrialSignupPage() {
  const [search] = useSearchParams();
  const [result, setResult] = useState(null);
  return <TrialFrame title="5 días para descubrir tu energía" subtitle="Explora Oráculo 365 con tu código de invitación. Crea tu cuenta y recibe tu acceso por correo.">
    {result ? <TrialSignupConfirmation result={result} /> : <RegisterForm trialOnly initialCode={search.get('code') || ''} onSuccess={setResult} />}
    <p className="text-center mt-6 text-sm text-gray-600">Calendario personal · Mensajes diarios · Perfiles Ninja</p>
  </TrialFrame>;
}
